import type { ProjectKpiProgressEntity } from '../entities/KpiEntity.js';
import type { IKpiRepository } from '../repositories/IKpiRepository.js';

interface Deps {
  kpiRepository: IKpiRepository;
}

export function createListProjectKpiProgressUseCase({ kpiRepository }: Deps) {
  return (orgId: string, projectIds: string[]): Promise<ProjectKpiProgressEntity[]> =>
    kpiRepository.listProjectProgress(orgId, projectIds);
}
